module.exports = __webpack_public_path__ + "7e4b29ba/img/google.68f3823e.svg";